import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import FeaturesContext from 'src/context/FeaturesContext';
import Tool from 'src/pages/tool/[uuid]';
import ToolMaintenancePage from 'src/pages/tool/[uuid]/maintenance';
import ToolActionPage from 'src/pages/tool/action';
import ScanRun from 'src/pages/tool/action/scan-run';
import PrivateRoute from 'src/routes/PrivateRoute';
import { FEATURES, isFeatureEnabled } from 'src/utils/features';

import NotFoundPage from '../pages/not-found';

const ToolRoutes = () => {
  const { features } = useContext(FeaturesContext);
  const isToolingEnabled = isFeatureEnabled(features, FEATURES.TOOLING_STOCK);

  return (
    <Routes>
      {isToolingEnabled && (
        <>
          <Route index path='/:uuid' element={<PrivateRoute Component={Tool} />} />
          <Route index path='/:uuid/action' element={<PrivateRoute Component={ToolActionPage} />} />
          <Route path='/:uuid/action/put-into-use' element={<PrivateRoute Component={ScanRun} />} />
          <Route
            path='/:uuid/maintenance'
            element={<PrivateRoute Component={ToolMaintenancePage} />}
          />
        </>
      )}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  );
};

export default ToolRoutes;
